import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';;
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import * as moment from 'moment';
import { AcademyCourtsService } from 'src/app/services/academy-courts.service';
import { CategoryService } from 'src/app/services/category.service';
import { Dropdown } from 'primeng/dropdown';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-player-courts',
  templateUrl: './player-courts.component.html',
  styleUrls: ['./player-courts.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class PlayerCourtsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  countdown: number = 10;
  countdownInProgress: boolean = false;
  username: string;
  userName;
  public item;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  WithdrawcnfModal: boolean = false;
  thankwithdraw: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 16
    },
    legend: {
      position: 'bottom'
    }
  }
  wid: any;
  tname: any;
  mtn: any;
  thankwithdrawinfo: boolean = false;
  agn: any;
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  skillsData: any;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public matchList: any = [];
  public lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public id;
  public searchby;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
  @ViewChild("pDropDownId3", { static: false }) pDropDownId3: Dropdown;
  playerCourtBookingList: any = [];
  morningSlots: any[] = [];
  afternoonSlots: any[] = [];
  eveningSlots: any[] = [];
  nightSlots: any[] = [];
  isSlotsAvailable: boolean = false;
  searchBy: any[] = [];
  sportList: any;
  courtTypeList: any[];
  bookingStatuses: any[];

  constructor(
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
    private confirmationService: ConfirmationService,
    private academyCourtsService: AcademyCourtsService,
    private categoryService: CategoryService
  ) {

  }
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id");

    this.searchBy = [
      { label: 'Booking Date', value: "bookingDate" }
    ];

    this.courtTypeList = [
      { label: 'Hard/Synthetic', value: 'synthetic' },
      { label: 'Grass', value: 'grass' },
      { label: 'Clay', value: 'clay' }
    ];

    this.bookingStatuses = [
      { label: 'Booked', value: 'Booked' },
      { label: 'Rejected', value: 'Rejected' },
      { label: 'Cancelled', value: 'Cancelled' }
    ];

    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }

    //this.loadAcademyCourtBookingDetails(this.lazyLoadEvent);
    this.getUserDetails(this.id);
    this.getSportList();
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.sportList = [];
      let sportTypeList = data.data.items;
      sportTypeList.forEach(ele => {
        this.sportList.push({ label: ele.name, value: ele.slug });
      })
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'courtName', 'contains');
    this.dt.filter('', 'academyName', 'contains');
    this.dt.filter('', 'courtType', 'contains');
    this.dt.filter('', 'sportType', 'contains');
    this.dt.filter('', 'bookingStatus', 'contains');
    this.dt.filter('', 'slotTotalAmount', 'contains');
    this.pDropDownId1.clear(null);
    this.pDropDownId2.clear(null);
    this.pDropDownId3.clear(null);
    if (this.pDropDownId1) {
      this.pDropDownId1.value = null;
    }
    if (this.pDropDownId2) {
      this.pDropDownId2.value = null;
    }
    if (this.pDropDownId3) {
      this.pDropDownId3.value = null;
    }
  }

  loadAcademyCourtBookingDetails(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    var query = "?filterByDisable=false&filterByStatus=true&filterByUserId=" + this.id;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      // params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartTime=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndTime=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (event.filters != undefined && event.filters["courtName"] != undefined) {
      params += "&filterByCourtName=" + event.filters["courtName"].value;
    }
    if (event.filters != undefined && event.filters["academyName"] != undefined) {
      params += "&filterByAcademyName=" + event.filters["academyName"].value;
    }
    if (event.filters != undefined && event.filters["courtType"] != undefined) {
      params += "&filterByCourtTypeName=" + event.filters["courtType"].value;
    }
    if (event.filters != undefined && event.filters["sportType"] != undefined) {
      params += "&filterBySportTypeName=" + event.filters["sportType"].value;
    }
    if (event.filters != undefined && event.filters["bookingStatus"] != undefined) {
      params += "&filterByBookingStatus=" + event.filters["bookingStatus"].value;
    }
    if (event.filters != undefined && event.filters["slotTotalAmount"] != undefined) {
      params += "&filterBySlotTotalAmount=" + event.filters["slotTotalAmount"].value;
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    this.academyCourtsService.getCourtBookingDetails(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.playerCourtBookingList = data.data.items;
        this.totalRecords = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  checkBookingDateValidator(academyCourtBooking) {
    const bookingDate = moment(academyCourtBooking?.bookingDate).format('YYYY-MM-DD');
    const courtSlotStartTime = academyCourtBooking?.mergedBookCourtSlots[0]['startTime'];
    const formattedBookingDate = moment(`${bookingDate} ${courtSlotStartTime}`, 'YYYY-MM-DD hh A').toDate();
    const currentDate = new Date();
    const isBookingDatePassed = moment(formattedBookingDate).isAfter(currentDate);
    return isBookingDatePassed;
  }

  onShowSlots(playerCourtBooking) {
    this.isSlotsAvailable = true;
    this.morningSlots = this.slotTimeFilterFunc(playerCourtBooking.mergedBookCourtSlots, 'MorningSlot');
    this.afternoonSlots = this.slotTimeFilterFunc(playerCourtBooking.mergedBookCourtSlots, 'AfternoonSlot');
    this.eveningSlots = this.slotTimeFilterFunc(playerCourtBooking.mergedBookCourtSlots, 'EveningSlot');
    this.nightSlots = this.slotTimeFilterFunc(playerCourtBooking.mergedBookCourtSlots, 'NightSlot');
  }

  slotTimeFilterFunc(bookCourtSlots, slotName) {
    return bookCourtSlots.filter(ele => ele.slot_name === slotName);
  }

  onCancelBooking(playerCourtBooking) {
    this.confirmationService.confirm({
      message: `
      <h4 style="margin:0;">Are you sure you want to cancel the booking?</h4>
      <p style="margin-top:10px;">
        Your booking will be cancelled if you proceed with the cancellation.
      </p>
    `,


      // message: "Your booking will be cancelled if you proceed with the cancellation.",
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes, Cancel',
      accept: () => {
        const cancelBookingObj = {
          cancel: true,
          slotIds: playerCourtBooking?.slotIds,
          setAvailibityId: playerCourtBooking?.setAvailibityId
        }

        this.academyCourtsService.updateCourtBookingDetails(playerCourtBooking.id, cancelBookingObj).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.messageService.add({ key: "toastmsg", severity: "success", summary: "Successful", detail: "Court Booking has been rejected!", life: 3000 });
          setTimeout(() => {
            this.loadAcademyCourtBookingDetails(this.lazyLoadEvent);
          }, 1000);
        }, err => {
          this.errorMessage = err.error.message;
        })
      },
      rejectLabel: 'Back',
      reject: () => {

      },
    });
  }

  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
          this.userName = this.profileDetails?.fullName;
        }

      }, err => {

      });

  }

  getCareerDetails() {
    this.careerService.getCareerDetails().then(
      data => {

        this.careerDetails = data[0];

      }, err => {

      });
  }

  getOpponentsList() {
    this.opponentsService.getOpponentsList().then(
      data => {
        this.opponentList = data;


      }, err => {

      }
    )
  }
  getHighestSkillJumpData() {
    this.careerService.getHighestSkillJumpDetails().then(
      data => {

        this.highestSkillJumpDetails = data;

      }, err => {

      });
  }

  getTournamentsList() {
    this.tournamentsService.getTournamentsList().then(
      data => {
        console.log('tournamentList', data);
        this.tournamentList = data;

      }, err => {

      });
  }
  startCountdown(): void {
    this.countdownInProgress = true;
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.countdownInProgress = false;
      }
    }, 1000);
  }

  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }

  // withdrawModal(){
  //   this.WithdrawcnfModal = true;
  // }
  withdrawModal(wid, tname, mtn, agn) {
    this.WithdrawcnfModal = true;
    this.wid = wid;
    this.tname = tname;
    this.mtn = mtn;
    this.agn = agn;
  }
  // thankyouwithdraw(){
  //   this.thankwithdraw = true;
  //   this.WithdrawcnfModal = false;
  // }
  thankyouwithdraw() {

    this.WithdrawcnfModal = false;
    const wbody = {
      disable: true,
      playerId: this.id
    };
    this.tournamentsService.getwithdrawamount(this.wid, wbody).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.wid = "";
        this.tname = "";
        this.mtn = "";
        this.agn = "";
        //console.log("Updated Tournament Player:", res);
        this.thankwithdrawinfo = true;
        this.countdownInProgress = true;
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(interval);
            this.countdownInProgress = false;
            window.location.reload();
          }
        }, 1000);
        // this.thankwithdraw = true;
        // setTimeout(() => {
        //   window.location.reload();
        // }, 6000);
      },
      (error) => {
        // Handle error (e.g., show an error message)
        console.error('Error updating tournament player:', error);
      }
    );
  }

   ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
